import { Outlet } from "react-router-dom";

export const RecruitingClientContainer = () => {
    return <Outlet />;
};
